import { Injectable } from '@angular/core';
import { DocumentRequestBatchesDataService } from '@wtax/data-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { mapClientDocumentOverviewResponse, mapDocumentOverviewResponse } from '../models/document-overview.mapper';
import { ClientDocumentOverviewCursors, DocumentOverviewModel } from '../models/document-overview.models';

@Injectable({
  providedIn: 'root',
})
export class DocumentOverviewService {
  constructor(private readonly documentRequestBatchesDataService: DocumentRequestBatchesDataService) {}

  public getDocumentOverview$(batchId: string): Observable<DocumentOverviewModel> {
    return this.documentRequestBatchesDataService.getDocumentOverview(batchId).pipe(map(mapDocumentOverviewResponse));
  }

  public getClientDocumentOverview$(cursors: ClientDocumentOverviewCursors = {}): Observable<DocumentOverviewModel> {
    return this.documentRequestBatchesDataService
      .getClientDocumentOverview(cursors.requestedAfter, cursors.reuploadNeededAfter, cursors.awaitingApprovalAfter, cursors.approvedAfter)
      .pipe(map(mapClientDocumentOverviewResponse));
  }
}
